// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


const envObject = {
  // serviceUrl : 'http://localhost:4003/api/v1', //local
  // serviceUrl : 'http://213.199.57.102:4003/api/v1' //uat
   serviceUrl : 'http://api.muhsems.ac.in/api/v1' //prod
};
export const environment = {
  production: false,
  serviceUrl: envObject.serviceUrl,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.